<div class="page justify-center items-center">
  <h1>404</h1>
</div>
